import { Asset } from './asset';

export class AssetResponse {
  status: number;
  controller: string;
  action: string;
  result: Asset;
}

export class Cart {
  cartItems: CartItem[];
}

export class CartItem { 
  parentDocId: number;
  parentDocTitle: string;
  ticNumber: string;
  infoType: string;
  docType: string;
  childDocCount: number;
}